﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum předání</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.handedOverInvestorDate" [maxToday]="true"/></div>
  </div>
</fieldset>
